import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Spacing } from '@zep/ui';
import { Tabs } from '@zep/ui/experimental';
import { isMobileDevice } from '@zep/utils';
import { PaymentTypeTabs } from '../PaymentTypeTabs';
import { PayTabsContent } from '../PayTabsContent';
import S from '../PricingPlans.module.scss';
import { OneTimePaymentBanner } from './OneTimePaymentBanner';
export const NormalPlans = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const [activeTab, setActiveTab] = useState<'yearly-pay' | 'monthly-pay'>('yearly-pay'); // Track active tab

  // Determine priceType and subscriptionPeriod based on the active tab
  const isYearly = activeTab === 'yearly-pay';
  const priceType = isYearly ? 'yearly' : 'monthly';
  const subscriptionPeriod = isYearly ? '365' : '30';
  const handleTabChange = (value: string) => {
    // Narrowing down to 'yearly-pay' | 'monthly-pay'
    if (value === 'yearly-pay' || value === 'monthly-pay') {
      setActiveTab(value);
    }
  };
  return <>
      <section className={S.section}>
        <div className={S.inner}>
          <div className={S.title}>
            <h1>
              {t('subscription:pricing.title', '적합한 플랜을 합리적인 가격으로 이용해보세요 ')}
            </h1>
          </div>

          <Tabs defaultValue="yearly-pay" onValueChange={handleTabChange} data-sentry-element="Tabs" data-sentry-source-file="NormalPlans.tsx">
            <PaymentTypeTabs data-sentry-element="PaymentTypeTabs" data-sentry-source-file="NormalPlans.tsx" />

            {!isMobileDevice() && <Spacing size={10} />}
            <PayTabsContent priceType={priceType} subscriptionPeriod={subscriptionPeriod} data-sentry-element="PayTabsContent" data-sentry-source-file="NormalPlans.tsx" />
          </Tabs>
        </div>
      </section>
      <OneTimePaymentBanner data-sentry-element="OneTimePaymentBanner" data-sentry-source-file="NormalPlans.tsx" />
    </>;
};